import { useCallback, useEffect, useRef, useState } from "react";

import { COPY_SUCCESS_FEEDBACK_DEFAULT_DURATION_MS } from "../constants";

type UseCopySuccessFeedbackOptions = {
    durationMs?: number;
};

type UseCopySuccessFeedbackReturn = {
    isCopied: boolean;
    notifyCopySuccess: () => void;
};

export const useCopySuccessFeedback = (
    options?: UseCopySuccessFeedbackOptions,
): UseCopySuccessFeedbackReturn => {
    const { durationMs = COPY_SUCCESS_FEEDBACK_DEFAULT_DURATION_MS } = options ?? {};
    const [isCopied, setIsCopied] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearTimer = useCallback(() => {
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    useEffect(() => {
        return () => clearTimer();
    }, [clearTimer]);

    const notifyCopySuccess = useCallback(() => {
        clearTimer();
        setIsCopied(true);
        timeoutRef.current = setTimeout(() => {
            setIsCopied(false);
            timeoutRef.current = null;
        }, durationMs);
    }, [clearTimer, durationMs]);

    return { isCopied, notifyCopySuccess };
};
